import CloseIcon from '@mui/icons-material/Close';
import { Alert, Box, CircularProgress, Dialog, DialogContent, IconButton } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useState } from 'react';

interface IVideoModalProps {
  isOpen: boolean;
  handleClose: () => void;
  videoUrl: string;
}

const VideoModalComponent = ({ isOpen, handleClose, videoUrl }: IVideoModalProps) => {
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isOpen && videoUrl) {
      setIsLoading(true);
      setError(false);
    }
  }, [isOpen, videoUrl]);

  const handleCloseInternal = () => {
    handleClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleCloseInternal}
      maxWidth="xl"
      fullWidth
      PaperProps={{
        sx: { maxHeight: '95vh', height: 'auto' }
      }}
    >
      <Box position="absolute" top={8} right={8} zIndex={10}>
        <IconButton onClick={handleCloseInternal} sx={{ bgcolor: 'rgba(255,255,255,0.7)', '&:hover': { bgcolor: 'rgba(255,255,255,0.9)' } }}>
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent sx={{
        p: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '50vh',
        bgcolor: 'background.default'
      }}>

        {isLoading && !error && (
          <CircularProgress sx={{ position: 'absolute' }} />
        )}

        {error ? (
          <Box p={4}>
            <Alert severity="error" variant="standard">
              {t('schoolMonitoring.errorPlayingVideo', 'Não foi possível reproduzir este vídeo.')}
            </Alert>
          </Box>
        ) : (
          videoUrl && (
            <video
              controls
              autoPlay
              src={videoUrl}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                display: isLoading ? 'none' : 'block',
                 maxHeight: '90vh'
              }}
              onLoadedData={() => setIsLoading(false)}
              onError={() => {
                setIsLoading(false);
                setError(true);
              }}
            />
          )
        )}
      </DialogContent>
    </Dialog>
  );
};

export default VideoModalComponent;